module.exports = __webpack_public_path__ + "static/media/tendericon01@3x.f64e2e58.png";